import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { orderBy } from 'lodash';
function primaryFirstSort(_ref) {
  var _context2;
  var _ref$arr = _ref.arr,
    arr = _ref$arr === void 0 ? [] : _ref$arr,
    sortByProperty = _ref.sortByProperty,
    _ref$primaryProperty = _ref.primaryProperty,
    primaryProperty = _ref$primaryProperty === void 0 ? 'is_primary' : _ref$primaryProperty;
  var ordered = orderBy(arr, sortByProperty);
  var primary = [];
  var nonPrimary = _reduceInstanceProperty(ordered).call(ordered, function (acc) {
    var _context;
    var curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (curr[primaryProperty]) {
      primary.push(curr);
      return acc;
    }
    return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(acc), [curr]);
  }, []);
  return _concatInstanceProperty(_context2 = []).call(_context2, primary, _toConsumableArray(nonPrimary));
}
export default primaryFirstSort;
//# sourceMappingURL=primaryFirstSort.js.map